/* eslint-disable import/no-anonymous-default-export */
import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'
import { parseCookies } from 'nookies'

export const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BACKEND_URL,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Authorization',
    'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
  },
})

export const onRequest = async (req: InternalAxiosRequestConfig<any>) => {
  const { olp_token } = parseCookies(undefined, {
    path: '/',
  })

  if (olp_token) {
    const olp_tokenParsed = JSON.parse(olp_token) as string

    if (olp_tokenParsed) {
      req.headers.Authorization = `Bearer ${olp_tokenParsed}`
    }
  }

  return req
}

export const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error)
}

export const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response
}

export const onResponseError = async (error: AxiosError) => {
  return error
}

apiClient.interceptors.request.use(onRequest, onRequestError)

export default { apiClient }
